import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MaintenanceService {

    private maintenanceModeSubject = new BehaviorSubject<boolean>(false);

    constructor() { }

    /**
     * Ativa o modo de manutenção
     */
    public activateMaintenanceMode(): void {
        this.maintenanceModeSubject.next(true);
    }

    /**
     * Desativa o modo de manutenção
     */
    public deactivateMaintenanceMode(): void {
        this.maintenanceModeSubject.next(false);
    }

    /**
     * Verifica se está em modo de manutenção
     */
    public isMaintenanceMode(): boolean {
        return this.maintenanceModeSubject.value;
    }

    /**
     * Verifica se uma requisição deve ser bloqueada
     */
    public shouldBlockRequest(url: string): boolean {
        // Nunca bloquear requisições para /api/status (usado para checagem de disponibilidade)
        if (url.includes('/api/status') || url.endsWith('status') || url.includes('status?noLoader=true')) {
            return false;
        }
        return this.isMaintenanceMode();
    }
}

